import {SimStats} from "./calculation/SimStats";

export interface RiotItemJSON {
	stats:{
		FlatMovementSpeedMod:number;
		FlatHPPoolMod:number;
		FlatCritChanceMod:number;
		FlatMagicDamageMod:number;
		FlatMPPoolMod:number;
		FlatArmorMod:number;
		FlatSpellBlockMod:number;
		FlatPhysicalDamageMod:number;
		PercentAttackSpeedMod:number;
		PercentLifeStealMod:number;
		FlatHPRegenMod:number;
		PercentMovementSpeedMod:number;
	}
	name:string;
	"image": {
		"full": "1082.png",
		"sprite": "item0.png",
		"group": "item",
		"x": 288,
		"y": 96,
		"w": 48,
		"h": 48
	},
}

export default class SimItem extends SimStats{

	name:string;
	fullImageName: string;

	constructor(item:RiotItemJSON){
		super();

		this.name = item.name;

		//TODO deal with attack speed when we deal with it in SimStats
		this.H = item.stats.FlatHPPoolMod;
		this.MS = item.stats.FlatMovementSpeedMod;
		this.C = item.stats.FlatCritChanceMod;
		this.AP = item.stats.FlatMagicDamageMod;
		this.MA = item.stats.FlatMPPoolMod;
		this.A = item.stats.FlatArmorMod;
		this.MR = item.stats.FlatSpellBlockMod;
		this.AD = item.stats.FlatPhysicalDamageMod;
		this.PLS = item.stats.PercentLifeStealMod;
		this.HR = item.stats.FlatHPRegenMod;

		this.fullImageName = item.image.full
	}

}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/ItemInfo.ts